module.exports = __webpack_public_path__ + "static/media/img-01.46671f72.jpg";